import { GroupBy } from '@/modules/common/types';

import { UserInfoColumnKey } from '../../constants/user-info-columns';
import { PlannerPreferences } from '../../types/utilization-filters';
import { PlannerFilters, PlannerStore, UserInfoVisibility } from '../types';

/**
 * What the planner persists and where. ALL persistence goes through the single
 * zustand `persist` middleware under this storage key — never hand-roll
 * localStorage reads/writes in slices (see hydration.ts for the read side).
 */
export const PLANNER_PREFERENCES_STORAGE_KEY = 'planner-preferences';

/**
 * Persisted keys that must NOT be synced to URL params. The URL storage flattens
 * nested objects into top-level params, so syncing userInfoVisibility would emit
 * `isManager=…`/`memberManager=…` params that COLLIDE with the planner filter
 * keys of the same names (and would hydrate back as filters).
 */
export const PLANNER_URL_EXCLUDED_PERSIST_KEYS = ['userInfoVisibility', 'userInfoOrder'];

export interface PlannerPersistedState {
  groupBy: GroupBy;
  zoomLevel: number;
  filters: PlannerFilters;
  plannerPreferences: PlannerPreferences;
  /** Persisted as an array (Set is not JSON-serializable) */
  collapsedGroups: string[];
  userInfoVisibility: UserInfoVisibility;
  userInfoOrder: UserInfoColumnKey[];
}

export const partializePlannerState = (state: PlannerStore): PlannerPersistedState => ({
  zoomLevel: state.zoomLevel,
  collapsedGroups: Array.from(state.collapsedGroups),
  filters: state.filters,
  groupBy: state.groupBy,
  plannerPreferences: state.plannerPreferences,
  userInfoVisibility: state.userInfoVisibility,
  userInfoOrder: state.userInfoOrder,
});
